/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { gridBaseLineInt } from '../../base-styles/vars';
import {
  button,
  container,
  buttonLess,
  buttonWhite,
} from './styles.module.css';

const lineHeightValueDefault = gridBaseLineInt;
const lineHeightUnitDefault = 'rem';

/**
 * Read More presentational component.
 */
const ReadMore = (props) => {
  const {
    className,
    collapsed,
    isOverflowing,
    content,
    html,
    lineCount,
    onClick,
    onRef,
    whiteBg,
    text,
    lineHeightValue,
    lineHeightUnit,
  } = props;

  const lineHeight = `${lineHeightValue}${lineHeightUnit}`;
  const paddingBottom = isOverflowing && !collapsed ? lineHeight : 'none';

  return (
    <div
      className={classnames(container, className)}
      ref={onRef}
      style={{
        maxHeight: collapsed
          ? `${lineCount * lineHeightValue}${lineHeightUnit}`
          : 'none',
        lineHeight,
        paddingBottom,
      }}
    >
      {html ? <div dangerouslySetInnerHTML={{ __html: content }} /> : content}
      {isOverflowing && (
        <button
          style={{ lineHeight, minHeight: lineHeight }}
          type="button"
          onClick={onClick}
          className={classnames({
            [buttonWhite]: whiteBg,
            [button]: collapsed,
            [buttonLess]: !collapsed,
          })}
        >
          {collapsed ? text || 'Read more' : 'Read less'}
        </button>
      )}
    </div>
  );
};

ReadMore.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  isOverflowing: PropTypes.bool,
  lineHeightValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lineHeightUnit: PropTypes.string,
  whiteBg: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  html: PropTypes.bool,
  lineCount: PropTypes.number,
  onClick: PropTypes.func,
  onRef: PropTypes.func,
};

ReadMore.defaultProps = {
  className: '',
  collapsed: true,
  whiteBg: false,
  isOverflowing: true,
  lineHeightValue: lineHeightValueDefault,
  lineHeightUnit: lineHeightUnitDefault,
  html: false,
  lineCount: 3,
  onClick: () => {},
  onRef: () => {},
  content: '',
  text: 'Read more',
};

export default ReadMore;
